/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Start_Pick_VehicleInputs */

const vi_cdo_start_pick_vehicle = /** @type {(inputs: Cdo_Start_Pick_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn phương tiện`)
};

/**

* @param {Cdo_Start_Pick_VehicleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_start_pick_vehicle = /** @type {((inputs?: Cdo_Start_Pick_VehicleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Start_Pick_VehicleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_start_pick_vehicle(inputs)
});